import { Link } from 'react-router-dom';

export default function CSOCard({ cso, adminMode = false }) {
  const initials = cso.acronym || (cso.org_name || '').slice(0, 2).toUpperCase();
  const profileLink = adminMode ? `/admin/organisations/${cso.id}` : `/csos/${cso.slug}`;

  return (
    <div className="cso-card card-hover">
      <div className="cso-card-header">
        <div className="cso-logo">
          {cso.logo_url
            ? <img src={cso.logo_url.startsWith('/') ? `${cso.logo_url}` : cso.logo_url} alt={cso.org_name}/>
            : initials}
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontWeight:700, fontSize:'0.9rem', lineHeight:1.3, color:'var(--gray-800)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {cso.org_name}
          </div>
        </div>
        {cso.zan_certified && <span className="zan-badge" style={{ fontSize:'0.68rem', padding:'2px 7px' }}>✓ Verified</span>}
      </div>

      <div className="cso-card-body">
        {cso.mission && (
          <p style={{ fontSize:'0.8rem', color:'var(--gray-500)', lineHeight:1.5, marginBottom:10,
            display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>
            {cso.mission}
          </p>
        )}

        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
          {(cso.province || cso.district) && (
            <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:'0.75rem', color:'var(--gray-500)' }}>
              <span>📍</span>
              <span>{[cso.district, cso.province].filter(Boolean).join(', ')}</span>
            </div>
          )}
          {cso.reg_number && (
            <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:'0.75rem', color:'var(--gray-500)' }}>
              <span>🪪</span><span>{cso.reg_number}</span>
            </div>
          )}
        </div>

        {/* Thematic tags */}
        {cso.thematic_areas?.length > 0 && (
          <div style={{ display:'flex', gap:4, flexWrap:'wrap', marginTop:10 }}>
            {cso.thematic_areas.slice(0,2).map((t,i) => (
              <span key={i} className="badge badge-green" style={{ fontSize:'0.68rem' }}>{t}</span>
            ))}
            {cso.thematic_areas.length > 2 && (
              <span className="badge badge-gray" style={{ fontSize:'0.68rem' }}>+{cso.thematic_areas.length-2}</span>
            )}
          </div>
        )}
      </div>

      <div className="cso-card-footer">
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
          {cso.cluster_ovc      && <span className="badge badge-purple" style={{ fontSize:'0.66rem' }}>OVC</span>}
          {cso.cluster_kp       && <span className="badge badge-red"    style={{ fontSize:'0.66rem' }}>KP</span>}
          {cso.cluster_health   && <span className="badge badge-green"  style={{ fontSize:'0.66rem' }}>Health</span>}
          {cso.cluster_gender   && <span className="badge badge-blue"   style={{ fontSize:'0.66rem' }}>Gender</span>}
          {cso.cluster_advocacy && <span className="badge badge-orange" style={{ fontSize:'0.66rem' }}>Advocacy</span>}
        </div>
        <Link to={profileLink} className="btn btn-sm btn-primary">View →</Link>
      </div>
    </div>
  );
}